
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-proposal",
      function () {
        return require("private-next-pages/get-proposal/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-proposal"])
      });
    }
  